import Heading from 'common/components/Heading';
import Image from 'common/components/Image';
import Text from 'common/components/Text';
import Container from 'common/components/UI/Container';
import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import Fade from 'react-reveal/Fade';
import {StaticImage} from 'gatsby-plugin-image';
import Section, {
  Content, FeatureGroup,
  FeatureItem, Figure, FigureWrapper, Grid, SectionHeading
} from './experience.style';


const WalletExperience = ({props}) => {

  return (
    <Section {...props}>
      <Container width="1400px">
        <Grid>
          <FigureWrapper>
              <Figure>
                <StaticImage
                  src={"../../../common/assets/image/lp/follow-unfollow2.png"}
                  alt="フォローバックユーザーの制御"
                />
              </Figure>
          </FigureWrapper>
          <Content>
            <SectionHeading>
              <Text className="subtitle" content={"Auto Follow & UnFollow"} />
              <Heading content={"自動フォロー・フォロー解除"} />
              <Text
                className="description"
                content={`１日最大で500フォローまで可能。フォロー解除も自動化できます。
「キーワード」「ハッシュタグ」「エリア」など、様々な条件で抽出したツイートのアカウントをフォローします。
                  `}
              />
            </SectionHeading>
            <FeatureGroup>
              <FeatureItem key={1}>
                <figure>
                  <StaticImage
                    src={"../../../common/assets/image/lp/unfollow.png"}
                    alt="フォローバックユーザーの制御"
                  />
                </figure>
                <div>
                  <Heading as="h4" content={"フォローバックしてくれたユーザー"} />
                  <Text
                    className="description"
                    content={"フォローバックしてくれたユーザーだけ、フォロー解除しないよう制御できます。"}
                  />
                </div>
              </FeatureItem>
              <FeatureItem key={1}>
                <figure>
                  <StaticImage
                    src={"../../../common/assets/image/lp/blacklist.png"}
                    alt="特定のアカウントを自動フォローしない"
                  />
                </figure>
                <div>
                  <Heading as="h4" content={"ブラックリスト機能"} />
                  <Text
                    className="description"
                    content={"特定のアカウントのアカウントをフォローしないようにできます。"}
                  />
                </div>
              </FeatureItem>
            </FeatureGroup>
          </Content>
        </Grid>
      </Container>
    </Section>
  );
};

export default WalletExperience;
